import Api from 'src/api/Base'

class ExportAllChangeControlsByCycleId extends Api {
  requestUrl = `/api/Cycle/${this.getParams().cycleId}/ExportAllChangeControls`
}

export default ExportAllChangeControlsByCycleId
